<template>
  <el-dialog
    :title="eventTitle + ' - ' + '报名表'"
    :before-close="handleClose"
    :visible.sync="dialog"
    :wrapperClosable="false"
    :close-on-click-modal="false"
    :fullscreen="true"
    custom-class="bigFormDialog"
  >
    <!--报名表内容-->
    <RegistrationFormContent
      ref="child"
      :eventId="eventId"
      :submitTimer="submitTimer"
      @loading="loadingVal"
      @newtimer="newSubmitTimer"
      @parentBlRegBtn="parentBlRegBtnVal"
    />
    <!--报名表底部提交/取消按钮-->
    <div class="formDialog__footer">
      <el-button @click="cancelForm">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">{{
        loading ? '提交中 ...' : '提交报名表'
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import RegistrationFormContent from '@/components/RegistrationFormContent';

export default {
  name: 'RegistrationForm',
  components: {
    RegistrationFormContent,
  },
  props: {
    showRegistrationForm: {
      type: Boolean,
      default: false,
    },
    eventTitle: String,
    eventId: Number,
    blRegBtn: Boolean,
  },
  data() {
    return {
      loading: false,
      submitTimer: null,
    };
  },
  methods: {
    loadingVal(data) {
      this.loading = data;
    },
    parentBlRegBtnVal(data) {
      this.parentBlRegBtn = data;
    },

    handleClose() {
      this.cancelForm();
    },
    cancelForm() {
      this.loading = false;
      clearTimeout(this.submitTimer);
      this.dialog = false;
    },
    handleSubmit() {
      if (this.loading) {
        return;
      }
      this.$refs.child.handleSubmit();
    },
    newSubmitTimer(data) {
      this.submitTimer = data;
    },
  },
  computed: {
    dialog: {
      get() {
        return this.showRegistrationForm;
      },
      set(v) {
        this.$emit('blRegistrationForm', v);
      },
    },
    // 报名按钮在提交表单成功后禁用
    parentBlRegBtn: {
      get() {
        return this.blRegBtn;
      },
      set(val) {
        this.$emit('blBtn', val);
      },
    },
  },
};
</script>

<style scoped></style>
